export enum TypeRoute {
  Home = '/',
  Redirect = '/redirect',
  SignIn = '/signin',
  SignUp = '/signup',
  ForgotPassword = '/forgot-password',
  Stores = '/stores',
  StoreInfo = '/store/:storeId',
  Ordering = '/store/:storeId/ordering',
  SubmitOrder = '/store/:storeId/ordering/submit',
  TableOrdering = '/store/:storeId/table/:tableId',
  TableSubmitOrder = '/store/:storeId/table/:tableId/submit',
  UserProfile = '/profile',
  PrivacyPolicy = '/privacy-policy',
}
